export default __webpack_public_path__ + "7aa5e9e4afbea770541f139d6c15d77f.png";